import { defineAsyncComponent } from 'vue';
import TabsPanelSpinner from '@components/TabsPanelTab/TabsPanelSpinner.vue';

/**
 * Helper function to load tabs asynchronically.
 * Use it like lazyLoadTab(() => import(...)) in your component definition to load a tba only when needed.
 */
export function lazyLoadTab(loader: () => Promise<{ default: unknown }>) {
    return defineAsyncComponent({
        loader,
        loadingComponent: TabsPanelSpinner,
    });
}

export { default } from './TabsPanel.vue';
